<template>
    <div>
        <b-modal size="xl" button-size="md" ref="finder" hide-footer :id="this.id" :title="prefix + title">
            <TipoGarantiaContratoList :showCamposCustomizados="true" @close="rowSelect" :prefix="prefix" />
        </b-modal>

        <lg-form-input-finder v-model="localObject" fieldDescription="descricao" :label="label"
            invalidFeedback="Tipo Garantia Contrato deve ser informado!" description=""
            @handleClean="rowSelect">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" pressed>
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </div>
</template>
<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";
import TipoGarantiaContratoList from "@/modules/cadastros/tipo-garantia-contrato/TipoGarantiaContratoList.vue";

export default {
    components: {
        LgFormInputFinder,
        TipoGarantiaContratoList,
    },

    props: {
        id: String,
        onDblClickLocalArmazenamentoList: Function,
        value: Object,
        label: {
            type: String,
            default: 'Tipo Garantia Contrato:'
        },
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Tipo Garantia Contrato",
        },

    },


    data() {
        return {
            localObject: this.value,
            garantiaContrato: "",
            fields: [
                {
                    key: "nome",
                    label: "Nome",
                    thClass: "pt-1 pb-0",
                    tdClass: "py-0 text-center col-1",
                },
            ],
        };
    },

    methods: {

        async show() {
            await this.$refs.finder.show();
            this.$bvModal.show(this.id);
        },

        async rowSelect(item) {
            this.localObject = item;
            this.$emit("close", item);
            await this.$bvModal.hide(this.id);
        },
    },
};
</script>
